import { render, staticRenderFns } from "./ProposalsEdit.vue?vue&type=template&id=025018bc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProposalsEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsEdit.vue?vue&type=style&index=0&id=025018bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025018bc",
  null
  
)

export default component.exports